import React from "react";
import "../../css/style.css";
import { connect } from "react-redux";
import Navigation from "../Navigation/Navigation";
import {
  payConveniencefee
} from "../../stores/actions/CommonAction";
import  Cancel  from "./Cancel";
import MerchantPaymentDataUtils from "../../utils/MerchantPaymentDataUtils";
import $ from "jquery";
import { SetConvenienceFeesDataForSelectedMode } from "../../stores/actions/PaymentModeAction";
import pl from "../../images/edge-powered-by-plural.svg";
import PopUp from "../HOC/PopUp";
import infoIcon from "../../images/info.svg";
import HeaderTopBar from "./HeaderTopBar";
import { ChangeTheme } from "../../Constants/MerchantTheme";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketamount: 0,
      conveniencefee: 0,
      overalltotoal: 0,
      first_run: true,
      convenienceFeesInPaisa: 0,
      convenienceFeesGSTInPaisa: 0,
      additionalChargesAmtInPaisa: 0,
      amount: 0,
      totalAmount: 0,
      isModelOpen: false,
    };
    this.objMerchantPaymentDataUtils = new MerchantPaymentDataUtils();
    this.error = null;
    this.loading = null;
    this.merchant_payment_data = null;
  }

  componentDidMount() {
    ChangeTheme(this.merchant_payment_data.merchant_data.merchant_id);
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 10) {
        $("#header").addClass("darkHeader");
      } else {
        $("#header").removeClass("darkHeader");
      }
    });
  }

  onClose = () => {
    this.setState({ isModelOpen: false });
  };

  convenienceFeeModal = () => {
    return (
      <div class="customModal">
        <div className="payment-breakup-title">Payment Breakup</div>
        <table class="feeTable">
          <tbody>
            <tr className="feeTableRow">
              <td>Order Total</td>
              <td class="feeAmount">{`₹${
                this.props?.paymentAmountUI && this.props?.paymentAmountUI / 100
              }`}</td>
            </tr>
            {(this.state?.convenienceFeesInPaisa) ? (
              <tr class="feeTableRow">
                <td>Convenience Fee</td>
                <td class="feeAmount">{`₹${(
                  (this.state.convenienceFeesInPaisa) /
                  100
                ).toFixed(2)}`}</td>
              </tr>
            ) : ""}

            {(this.state?.additionalChargesAmtInPaisa) ? (
              <tr class="feeTableRow">
                <td>Additional Charges</td>
                <td class="feeAmount">{`₹${(
                  (this.state.additionalChargesAmtInPaisa) /
                  100
                ).toFixed(2)}`}</td>
              </tr>
            ): ""}

            {this.state?.convenienceFeesGSTInPaisa ? (
              <tr class="feeTableRow">
                <td>GST on Convenience Fee</td>
                <td class="feeAmount">{`₹${(
                  this.state.convenienceFeesGSTInPaisa / 100
                ).toFixed(2)}`}</td>
              </tr>
            ) : ""}

            <tr className="totalCal">
              <td>Total Payable</td>
              <td class="feeAmount">{`₹${
                this.state?.totalAmount && this.state?.totalAmount / 100
              }`}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  irctcConvenienceFeeModal = () => {
    return (
      <div class="customModal">
        <div className="payment-breakup-title">Payment Breakup</div>
        <table class="feeTable">
          <tbody>
            <tr className="feeTableRow">
              <td>Ticket Amount</td>
              <td class="feeAmount">{`₹${
                (this.state.ticketamount / 100) || (this.props?.paymentAmountUI / 100)
              }`}</td>
            </tr>
            <tr class="feeTableRow">
              <td>PG Charges + 18% GST</td>
              <td class="feeAmount">{`₹${(this.state.conveniencefee / 100) % 1 == 0
                ? (this.state.conveniencefee / 100).toFixed()
                : (this.state.conveniencefee / 100).toFixed(2)}`}
              </td>
            </tr>

            <tr className="totalCal">
              <td>Total Fare</td>
              <td class="feeAmount">{`₹${
                (this.state.overalltotoal / 100) % 1 == 0
                ? (this.state.overalltotoal / 100).toFixed()
                : (this.state.overalltotoal / 100).toFixed(2)
              }`}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  payConveniencefee = (body) => {
    this.props
      .dispatch(payConveniencefee(body))
      .then((response) => {
        let responseData = JSON.parse(response.data);
        if (responseData.fee != undefined || responseData.total != undefined)
          this.setState({
            ticketamount: responseData.amount,
            conveniencefee: responseData.fee,
            overalltotoal: responseData.total,
            first_run: false,
          });
      })
      .catch((error) => {
        console.log(error);
      });
    return;
  };

  fetchConvenienceFees = (paymentModeId, networkCardType) => {
    const { conveniencefeeData } = this.props;
    const conveniencefeeDataObj =
      conveniencefeeData.data && conveniencefeeData.data.length !== 0
        ? conveniencefeeData.data
        : null;
    const selectedConveniencefeeData =
      this.objMerchantPaymentDataUtils.fetchConvenienceFeesHelper(
        conveniencefeeDataObj,
        paymentModeId,
        networkCardType
      );
    if (selectedConveniencefeeData) {
      this.setState({
        convenienceFeesInPaisa:
          selectedConveniencefeeData.convenience_fees_amt_in_paise || 0,
        convenienceFeesGSTInPaisa:
          selectedConveniencefeeData.convenience_fees_fees_gst_amt_in_paise ||
          0,
        additionalChargesAmtInPaisa:
          selectedConveniencefeeData.convenience_fees_fees_addition_amt_in_paise ||
          0,
        amount: selectedConveniencefeeData.transaction_amount || 0,
        totalAmount: selectedConveniencefeeData.final_amt_in_paise || 0,
      });
    } else {
      this.setState({
        convenienceFeesInPaisa: 0,
        convenienceFeesGSTInPaisa: 0,
        additionalChargesAmtInPaisa: 0,
        amount: 0,
        totalAmount: 0,
      });
    }
    this.props.dispatch(
      SetConvenienceFeesDataForSelectedMode(selectedConveniencefeeData)
    );
  };

  componentDidUpdate(prevProps) {
    const {
      isSurchargeEnabled,
      convenienceFeePaymentModeId,
      convenienceFeeCardNetworkType,
      conveniencefeeData,
    } = this.props;
    if (
      isSurchargeEnabled &&
      conveniencefeeData.data &&
      conveniencefeeData.data.length !== 0
    ) {
      if (
        (convenienceFeePaymentModeId &&
          convenienceFeePaymentModeId !==
            prevProps.convenienceFeePaymentModeId) ||
        (convenienceFeeCardNetworkType &&
          convenienceFeeCardNetworkType !==
            prevProps.convenienceFeeCardNetworkType)
      ) {
        if (
          (convenienceFeePaymentModeId === 1 ||
            convenienceFeePaymentModeId === 18) &&
          convenienceFeeCardNetworkType &&
          convenienceFeeCardNetworkType !==
            prevProps.convenienceFeeCardNetworkType
        ) {
          this.fetchConvenienceFees(
            convenienceFeePaymentModeId,
            convenienceFeeCardNetworkType
          );
        } else {
          this.fetchConvenienceFees(
            convenienceFeePaymentModeId,
            convenienceFeeCardNetworkType
          );
        }
      }
    }
  }

  render() {
    this.error = this.props.error;
    this.loading = this.props.loading;
    this.merchant_payment_data = this.props.merchant_payment_data;
    let merchant_id = 0;
    let amount = 0;
    let unique_merchant_txn_id = 0;
    let pinePgTxnId = 0;
    this.is_IRCTC = this.props.is_IRCTC;
    this.isSurchargeEnabled = this.props.isSurchargeEnabled;
    const isconveniencefeeData = this.props.conveniencefeeData.data && this.props.conveniencefeeData.data.length !== 0 ;
    const isconveniencefeeDataForPayMode = this.state?.convenienceFeesInPaisa || this.state?.convenienceFeesGSTInPaisa || this.state?.additionalChargesAmtInPaisa;
    if (
      this.merchant_payment_data &&
      this.merchant_payment_data !== undefined
    ) {
      merchant_id = this.merchant_payment_data.merchant_data.merchant_id;
      amount = this.merchant_payment_data.payment_data.amount_in_paisa;
      unique_merchant_txn_id =
        this.merchant_payment_data.merchant_data.unique_merchant_txn_id;
      pinePgTxnId = this.merchant_payment_data.txn_data.pine_pg_txn_id;
    }
    const merchantData = this.objMerchantPaymentDataUtils.GetMerchantData(
      this.merchant_payment_data
    );
    let conveniencefee = {
      merchantid: merchant_id,
      mode: "CC",
      amount: amount,
      unique_merchant_txn_id: unique_merchant_txn_id,
      pinePgTxnId: pinePgTxnId,
    };
    if (this.state.first_run && this.is_IRCTC) {
      this.payConveniencefee(conveniencefee);
    }
    const paymentData = this.objMerchantPaymentDataUtils.GetPaymentData(
      this.merchant_payment_data
    );
    if (!merchantData || !paymentData) {
      return null;
    }

    let MerchantImagelogo =
      this.objMerchantPaymentDataUtils.GetMerchantLogo(merchantData);
    if (MerchantImagelogo == null || MerchantImagelogo == "") {
      MerchantImagelogo = "";
    }
    return (
      <>
        <header id="header" class="clearfix fixed-top">
          <HeaderTopBar merchantLogoSrc={MerchantImagelogo}/>
          <Cancel merchantLogoSrc={MerchantImagelogo}/>
          <div class="transaction-header">
            <div class="container">
              <div class="merchant-details-irctc">
                <div class="header-rows">
                  <div class="pull-left p0 merchant-transaction">
                    <img src={pl} alt="plural" />
                  </div>
                  <div class="merchant-detail-section">
                    <>
                      <div class="pull-right text-end p10 total-amount-paid">
                        {this.is_IRCTC ? "Ticket Amount :" : "Order Total :"}{" "}
                        <br />{" "}
                        <span class="total-amount">
                          &#x20B9;
                          {this.is_IRCTC
                            ? (this.state.ticketamount / 100) % 1 == 0
                              ? (this.state.ticketamount / 100).toFixed()
                              : (this.state.ticketamount / 100).toFixed(2)
                            : this.isSurchargeEnabled && isconveniencefeeData && isconveniencefeeDataForPayMode ? ((this.state?.amount/ 100) % 1 == 0 ? (this.state?.amount/ 100).toFixed() : (this.state?.amount/ 100).toFixed(2)):(this.props?.paymentAmountUI / 100)}
                        </span>
                        {!this.is_IRCTC ? this.state.convenienceFeesInPaisa ||
                        this.state.convenienceFeesGSTInPaisa ||
                        this.state.additionalChargesAmtInPaisa ? (
                          <span
                            class="convenience-fee-container"
                            onClick={() => {
                              this.setState({
                                isModelOpen: true,
                              });
                            }}
                          >
                            {" "}
                            <span>
                              + &#x20B9;
                              {(this.state?.totalAmount / 100) % 1 == 0
                                ? (
                                    this.state.totalAmount / 100 -
                                    this.state?.amount / 100
                                  ).toFixed(2)
                                : (
                                    (this.state.totalAmount / 100).toFixed(2) -
                                    this.state?.amount / 100
                                  ).toFixed(2)}{" "}
                            </span>
                            <img src={infoIcon} alt="View fee" />
                          </span>
                        ) :("") : this.state.conveniencefee ? (
                          <span
                            class="convenience-fee-container"
                            onClick={() => {
                              this.setState({
                                isModelOpen: true,
                              });
                            }}
                          >
                          {" "}
                          <span>
                              + &#x20B9;
                              {(this.state.conveniencefee / 100) % 1 == 0
                              ? (this.state.conveniencefee / 100).toFixed()
                              : (this.state.conveniencefee / 100).toFixed(2)}{" "}
                            </span>
                            <img src={infoIcon} alt="View fee" />
                          </span>
                        ) :("")}{" "}
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <section className="surcharge-content mb10">
          <div className="container">
            <Navigation />
          </div>
        </section>
        {this.state.isModelOpen ? this.is_IRCTC ? (
          <PopUp onClose={() => this.onClose()}>
            {this.irctcConvenienceFeeModal()}
          </PopUp>
        ) : (
          <PopUp onClose={() => this.onClose()}>
            {this.convenienceFeeModal()}
          </PopUp>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    merchant_payment_data:
      state.merchantPaymentDataFetchingReducer.merchantPaymentData,
    is_IRCTC: state.merchantPaymentDataFetchingReducer.isIRCTC,  
    error: state.merchantPaymentDataFetchingReducer.error,
    loading: state.merchantPaymentDataFetchingReducer.loading,
    paymentAmountUI: state.merchantPaymentDataFetchingReducer.paymentAmountUI,
    paymentFee: state.merchantPaymentDataFetchingReducer.paymentfee,
    conveniencefee_data: state.merchantPaymentDataFetchingReducer.conveniencefeeData,
    paymentModeId: state.merchantPaymentDataFetchingReducer.paymentModeId,
    conveniencefeeData: state.merchantPaymentDataFetchingReducer.paymentModeWiseConvenienceFeesData,
    convenienceFeePaymentModeId: state.merchantPaymentDataFetchingReducer.convenienceFeePaymentModeId,
    convenienceFeeCardNetworkType: state.merchantPaymentDataFetchingReducer.convenienceFeeCardNetworkType,
    isSurchargeEnabled: state.merchantPaymentDataFetchingReducer.isSurchargeEnabled,
  };
};

export default connect(mapStateToProps)(Header);
